import BaseTextarea from './BaseTextarea.vue';
export default BaseTextarea;
